import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import translationEnglish from "./i18n/english.json";

const longDateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
const shortDateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit" };

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: translationEnglish },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    format(value, format, lng) {
      if (!(value instanceof Date)) return value;
      const locale = lng ?? "en";
      if (format === "fmt-long-date") return new Intl.DateTimeFormat(locale, longDateOptions).format(value);
      if (format === "fmt-short-date") return new Intl.DateTimeFormat(locale, shortDateOptions).format(value);
      return value.toISOString();
    },
  },
});

async function loadLocale(lang: "ja" | "es" | "ru"): Promise<void> {
  if (i18next.hasResourceBundle(lang, "translation")) return;
  const mod = await (
    lang === "ja" ? import("./i18n/japanese.json")
    : lang === "es" ? import("./i18n/spanish.json")
    : import("./i18n/russian.json")
  );
  i18next.addResourceBundle(lang, "translation", mod.default);
}

async function language(lang: string): Promise<void> {
  console.log(`Changing Language to ${lang}`);
  if (lang === "ja" || lang === "es" || lang === "ru") {
    await loadLocale(lang);
  }
  await i18next.changeLanguage(lang);
}

// for debug, change language from browser dev console
(window as any).language = language;
(window as any).ja = () => language("ja");
(window as any).en = () => language("en");
(window as any).es = () => language("es");
(window as any).ru = () => language("ru");

export default i18next;
